import { Button } from '@design/components/button/Button';
import animationData from '@static/animations/7_questions.json';
import { appPaths } from '@terminal/routes/app-paths';
import Lottie from 'lottie-react';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import styles from './NotFound.module.scss';

export const NotFound = () => {
  const { t } = useTranslation(['error', 'common']);
  const title = t('error:notFound.title');
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <main className={styles.main} data-testid="not-found-page">
        <section className={styles.notFoundSection}>
          <div>
            <div className={styles.animationContainer}>
              <Lottie loop autoplay animationData={animationData} />
            </div>
            <h1 className={styles.title} data-testid="title">
              {t('error:notFound.pageTitle')}
            </h1>
          </div>
          <p className={styles.description}>{t('error:notFound.pageText')}</p>
          <Button
            className={styles.linkButton}
            data-testid="back-action"
            onClick={() => navigate(appPaths.base)}
            label={t('error:notFound.pageButtonText')}
            size="large"
          />
        </section>
      </main>
    </>
  );
};
